<template>
  <div>
    <v-btn small @click="createCanvasLink()" class="mb-2">Canvas</v-btn>
    <v-btn small @click="createImageLink()" class="mb-2">Image</v-btn>
    <a v-if="download" ref="link" :href="link" :download="download">
      <v-btn small class="mb-2">Download</v-btn></a
    >
    <div ref="saveImage">
      <slot></slot>
    </div>
  </div>
</template>

<script>
import html2canvas from "html2canvas";
import domtoimage from "dom-to-image";
export default {
  name: "CoreSaveCanvas",
  props: {
    name: {
      type: String,
      default: "my-image",
    },
    background: {
      type: String,
      default: "#ffffff",
    },
  },
  data() {
    return {
      download: null,
      link: null,
    };
  },
  methods: {
    createCanvasLink() {
      const element = this.$refs.saveImage;
      const self = this;
      this.$emit("actions", false);
      this.$nextTick(() => {
        html2canvas(element, {
          scale: 2,
          backgroundColor: self.background,
          useCORS: true,
          imageTimeout: 0,
        }).then((canvas) => {
          var dataUrl = canvas.toDataURL("image/png");
          self.download = `${self.name}.png`;
          self.link = dataUrl;
          self.$nextTick(() => {
            const targetLink = self.$refs.link;
            targetLink.click();
            self.$emit("actions", true);
          });
        });
      });
    },
    createImageLink() {
      const targetDiv = this.$refs.saveImage;
      const self = this;
      this.$emit("actions", false);
      domtoimage
        .toPng(targetDiv, { scale: 2, quality: 1 })
        .then(function(dataUrl) {
          self.download = `${self.name}.png`;
          self.link = dataUrl;
          self.$nextTick(() => {
            const targetLink = self.$refs.link;
            targetLink.click();
            self.$emit("actions", true);
          });
        });
    },
  },
};
</script>

<style lang="postcss">
.gm-style-iw.gm-style-iw-c {
  overflow: visible;
}
</style>
